import React from 'react';

import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';

import type { KlpStyled } from '../Theme';
import { removeKlpStyles } from '../Theme';
import classnames from 'classnames';
import type { WithTranslation } from '../TranslationOrChildren';
import { TranslationOrChildren } from '../TranslationOrChildren';
import { useKlpStyles } from '../Theme/useKlpStyles';

export type ITypographyProps = WithTranslation &
    Partial<KlpStyled> &
    Partial<TypographyProps>;

export const Typography = (props: ITypographyProps) => {
    const {
        children,
        className,
        translation,
        translationOptions,
        ...restProps
    } = props;

    const klpStyles = useKlpStyles(props);

    return (
        <MUITypography
            className={classnames(klpStyles.klpStyles, className)}
            data-testid="Typography"
            {...removeKlpStyles(restProps)}
        >
            <TranslationOrChildren
                translation={translation}
                translationOptions={translationOptions}
            >
                {children}
            </TranslationOrChildren>
        </MUITypography>
    );
};
